import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from 'mobily-ui-library';
import { GlobalContext } from '../../context/GlobalContext';
import Loader from '../Loader/Loader';

import Map from './Map/Map';

import Close from '../../assets/Close.svg'

import './MapModal.scss';

interface Props {
    rtl: boolean;
    handleAddress?: any;
    handleMapModalClose: (flag: boolean) => void;
}

function MapModal({ rtl, handleAddress, handleMapModalClose }: Props) {
    const { t } = useTranslation();
    const { state, dispatch }: any = useContext(GlobalContext);
    const [address, setAddress] = useState('');
    const [cityName, setCityName] = useState('');
    const [region, setRegion] = useState('');
    const [addressLine, setAddressLine] = useState('');
    const [latLng, setLatLng] = useState({ lat: '', lng: '' });
    const [placeId, setPlaceId] = useState('');
    const [isAddressValid, setIsAddressValid] = useState(true);



    useEffect(() => {
        if (address && cityName) {
            setIsAddressValid(address.toLowerCase().includes(cityName.toLowerCase()));
        }
    }, [address]);

    const callbackAddress = (value: string, ltLg: any, placeId: any) => {
        if (ltLg) {
            setLatLng({ lat: ltLg.lat, lng: ltLg.lng });
            setAddress(value);
            setPlaceId(placeId);
            
        }
    }

    const callbackCityName = (cityName: any, region: string, address: string, placeId: string) => {
        if (cityName?.length > 0) {
            setCityName(cityName);
            setRegion(region);
            setAddressLine(address);
            setPlaceId(placeId);

        }
    }

    const handleConfirmAddress = async () => {
        console.log("Address mapmodal:", address, latLng, cityName, placeId);
        await handleAddress(address, latLng, cityName, placeId);
        dispatch({ type: "SET_ADDRESS_DETAILS", payload: { region, cityName, latLng, addressLine: address, placeId }, });
        handleMapModalClose(false);

    };

    console.log(state, addressLine);

    return (
        <>
            <Loader />
            <div className='DD__Map-Container'>
                <div className='DD__Map-Heading'>
                    <Typography className='DD__MapTitle'>{t('select_delivery_address')}</Typography>
                    <img src={Close} alt='close' onClick={() => handleMapModalClose(false)} />
                </div>
                <Map
                    rtl={rtl}
                    dispatch={dispatch}
                    loadCurrLoc={true}
                    callbackAddress={callbackAddress}
                    callbackCityName={callbackCityName}
                    placeholder={t("Delivery_address")}
                />
                {!isAddressValid && (
                    <div className="DD__ErrorWrapper">
                        <Typography className='DD_ErrorMessage' >{t("mapCityErrorMessage")} </Typography>
                    </div>
                )}

                <Button id={'select-address-btn'} onClick={handleConfirmAddress} className='DD__Map-select' variant={isAddressValid ? 'default' : 'disabled'} >{t('select')}</Button>
            </div>
        </>

    )
}

export default MapModal